import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';

@Component({
    selector: 'app-lite-school-shortcuts',
    templateUrl: './lite-school-shortcuts.component.html',
    styleUrls: ['./lite-school-shortcuts.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, MatIconModule, MatTooltipModule]
})
export class LiteSchoolShortcutsComponent {

  @Input() isTeacherOrEducatorStaffMember: boolean;
}
